import Ryu from "../../../assets/About/Ryuzaki.png";
import Agata from "../../../assets/About/Agata.png";
import Naruto from "../../../assets/About/Naruto.png";
import Vegeta from "../../../assets/About/Vegeta.png";
import Choper from "../../../assets/About/Choper.png";
import DevBraz from "../../../assets/About/DevBraz.png";
import DevWill from "../../../assets/About/DevWill.jpg";
import DevEric from "../../../assets/About/DevEric.jpg";
import DevEdson from "../../../assets/About/DevEdson.jpg";
import DevBrunno from "../../../assets/About/DevBrunno.jpg";

export const devsData = [
  {
    name: "Charles Braz",
    function: "Product Owner",
    devimg: DevBraz,
    animeimg: Ryu,
    infoparagraph1:
      "Quando criança gostava muito de editar mapas do jogo Warcraft III, nessas edições era utilizado muita lógica para fazer a idéia funcionar, era sempre muito prazeroso ver algo que você criou funcionando como esperado, porém, não tinha conhecimento sobre a área de programação e nem nada do tipo, então, quando cresci, acabei escolhendo outro caminho.",
    infoparagraph2:
      "Em meu último emprego surgiu uma vaga para o setor de análise de riscos, para concorrer a mesma havia-se uma necessidade do entendimento da lógica de programação, então, comecei a estudar logica em python e acabei gostando muito do que aprendi, foi que surgiu uma grande vontade de aprender mais sobre o mundo da programação, tomei uma grande decisão na minha vida, deixei de lado minha faculdade de engenharia civil já com um estágio ótimo para continuar o caminho como desenvolvedor, entrei na Kenzie Academy para estudar e aprender, agora finalizado meu curso, planejo começar a trabalhar como desenvolvedor e ampliar o conhecimento!",
    phraseauthor: "Albert Einstein",
    phrase: `"A imaginação é mais importante que o conhecimento, porque o conhecimento é limitado, ao passo que a imaginação abrange o mundo inteiro."`,
    linkedin: "https://www.linkedin.com/in/charlesbraz/",
    github: "https://github.com/devbraz",
    position: "9vw",
    offsety: "-50px",
    offsetx: "-50px",
    delay: "0s",
    id: 1,
  },
  {
    name: "William Baierle",
    function: "Scrum Master",
    devimg: DevWill,
    animeimg: Agata,
    infoparagraph1:
      "Opa! Te aprochega cupicho! Sou um desenvolvedor jovem-adulto residente no Brasil! Esperando algum dia dominar todas as linguages existentes, desejai-me sorte! XD",
    infoparagraph2:
      "Comecei por pesquisar e estudar com Python, clássico, estudando o tal junto a SQL e pouquíssimo sobre Java, os quais eram ditos os mais utilizados no momento/época, nos meados de 2016. O estudo não rendeu, por fim acabei por largar este estudo por si próprio e me focar em outras questões, como escola, família e meus próprios hobbies. Mas claro, sempre voltando e parando todos os anos, sem muito desenvolvimento do conhecimento. Quando o desejo batia novamente, como uma brasa indelével sempre querendo seguir esse caminho.",
    phraseauthor: "Cartola",
    phrase:
      "Se amanhã o que eu sonhei não for bem aquilo, eu tiro um arco-íris da cartola. E refaço. Colo. Pinto e bordo.",
    linkedin: "https://www.linkedin.com/in/william-baierle-dev/",
    github: "https://github.com/nittts",
    position: "29vw",
    offsety: "50px",
    offsetx: "50px",
    delay: "0.5s",
    id: 2,
  },
  {
    name: "Brunno Miguel",
    function: "Tech Leader",
    devimg: DevBrunno,
    animeimg: Naruto,
    infoparagraph1:
      "Olá, tudo certo? Sou um desenvolvedor web, mas trilhei por caminhos diferentes antes de encontrar o que me faz brilhar os olhos, a programação.",
    infoparagraph2:
      "Fui pra área do atendimento ao cliente como operador de telemarketing e depois servidor público na área da saúde. Nesse período cursei análise e desenvolvimento de sistemas, onde descobri o mundo da programação, daí um mundo novo de possibilidades surgiu e decidi que me tornaria um desenvolvedor web para assim resolver problemas e ajudar pessoas através de linhas de código.",
    phraseauthor: "A Procura da Felicidade",
    phrase:
      "Nunca deixe ninguém te dizer que não pode fazer alguma coisa. Se você tem um sonho tem que correr atrás dele. As pessoas não conseguem vencer e dizem que você também não vai vencer. Se você quer uma coisa corre atrás.",
    linkedin: "https://www.linkedin.com/in/brunno-miguel/",
    github: "https://github.com/brunnomiguel",
    position: "49vw",
    offsety: "-50px",
    offsetx: "0px",
    delay: "1s",
    id: 3,
  },
  {
    name: "Eric James",
    function: "Quality Assurance",
    devimg: DevEric,
    animeimg: Choper,
    infoparagraph1:
      "Estudante Front-End, na Kenzie Academy Brasil, com conhecimento em HTML, CSS, Javascript, React.js, buscando me especializar no Front-end, animado pra alcançar novos ares, ansiando por novos desafios.",
    infoparagraph2: "",
    phraseauthor: "",
    phrase: "",
    linkedin: "https://www.linkedin.com/in/eric-james-front/",
    github: "https://github.com/Ericjcf",
    position: "69vw",
    offsety: "50px",
    offsetx: "-50px",
    delay: "1.5s",
    id: 4,
  },
  {
    name: "Edson Vinícius",
    function: "Quality Assurance",
    devimg: DevEdson,
    animeimg: Vegeta,
    infoparagraph1:
      "Estudante e Dev front-end desde 2021, apaixonado por aprender novas tecnologias. Atualmente cursa segundo semestre de segurança da informação e está no segundo módulo na Kenzie Academy.",
    infoparagraph2: "",
    phraseauthor: "",
    phrase: "",
    linkedin: "https://www.linkedin.com/in/edson-vinicius-freitas-b21a82243/",
    github: "https://github.com/edsonvin",
    position: "88.5vw",
    offsety: "-50px",
    offsetx: "50px",
    delay: "2s",
    id: 5,
  },
];
